
<div class="index-list-view">
  <ftu-block
    dismiss-key="indexes"
    icon="assessment"
    title="These are indexes"
    description="The indexes below track the aggregate daily value movements of cards across various categories. The CL50 Index is like the S&P 500, made up of cards that were hand selected by our team. Use these indexes to research specific markets within the hobby to gauge where the markets are moving."
  />

  <page-header title="Indexes" />

  <align
    class="header"
    flex
    collapse-end
    direction="flex-start"
  >
    <div class="search-container">
      <search-area
        v-model="query"
        class="input"
      />
    </div>

    <align small-gap>
      <icon-button
        v-if="allowMoreCustomIndexes"
        icon="dashboard_customize"
        tooltip="Setup Custom Index"
        @click="showCustomIndexModal = true"
      />

      <direction-sort-options
        :sort.sync="sort"
        :direction.sync="direction"
        :options="sortOptions"
      />
    </align>
  </align>

  <div v-if="indexSnapshot">
    <div class="grid">
      <index-category-card
        v-for="index in filteredIndexes"
        :key="index.key"
        :as="index.as"
        :to="index.to"
        :text="index.label"
        :icon="index.icon"
        :highlight="index.custom"
        :percent-change="index.percentChange"
      />
    </div>
  </div>

  <portal to="fullscreen">
    <custom-index-setup-modal
      :open="showCustomIndexModal"
      @close="showCustomIndexModal = false"
      @updated="load"
    />
  </portal>
</div>
